/**
 *
 * ApexOnlineMenuData Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

var menuItems = function menuItems(state) {
  return state[NAMESPACE];
};

var menuItemsResults = createSelector(menuItems, function (service) {
  return service && service.menuItems;
});
var menuItemsError = createSelector(menuItems, function (service) {
  return service && service.error;
});

export default {
  menuItemsResults: menuItemsResults,
  menuItemsError: menuItemsError
};